var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ManagementPage", {
    attrs: {
      grid: true,
      fullPanel: true,
      pageName:
        _vm.$t("Data") + " / " + _vm.$t("Delete") + " " + _vm.$tc("Layer", 2)
    },
    scopedSlots: _vm._u([
      {
        key: "top-left",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "container" },
              [
                _c("div", { staticClass: "headers-container" }, [
                  _c("h3", [
                    _vm._v(_vm._s(_vm.$t("Delete") + " " + _vm.$tc("Layer", 2)))
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(_vm.$t("DeleteLayersMessage")))])
                ]),
                _vm._v(" "),
                _vm._l(_vm.fields, function(field) {
                  return _c(
                    "div",
                    {
                      key: field.label,
                      style: [{ width: "100%", overflow: "visible" }]
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "input-item" },
                        [
                          _c("input-field", {
                            key: field.varName,
                            attrs: {
                              "input-type": field.inputType,
                              value: field.value,
                              label: field.label,
                              "input-disabled": field.disabled,
                              "select-options-list": field.options,
                              disableBranchNodes: field.disableBranchNodes,
                              "checkbox-options": field.checkboxOptions,
                              min: field.min,
                              max: field.max,
                              step: field.step,
                              size: "large",
                              clearable: field.clearable,
                              required: field.required,
                              inputFieldContainerStyling: { padding: "0" },
                              "radio-options": field.radioOptions,
                              placeholder: field.placeholder,
                              "input-style": _vm.inputStyle
                            },
                            on: {
                              input: function($event) {
                                _vm.layer = $event
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                }),
                _vm._v(" "),
                _c("TableViewWorkspaces", {
                  ref: "tableWorkspacesView",
                  on: { "set-selected-workspace": _vm.setSelectedWorkspace }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "action-buttons" },
                  [
                    _c("custom-button", {
                      attrs: {
                        label: _vm.$t("Confirm"),
                        "button-color": "var(--app-primary-base)",
                        "label-color": "#FFF",
                        disabled: !(
                          _vm.layer &&
                          (_vm.selectedWorkspace.uuid || _vm.shapeGeom)
                        )
                      },
                      on: { buttonClick: _vm.fetchLayerObjects }
                    })
                  ],
                  1
                )
              ],
              2
            ),
            _vm._v(" "),
            _c("LoadingSpinner", {
              attrs: {
                active: _vm.loading,
                "is-full-page": true,
                color: "var(--app-primary-base)"
              },
              on: {
                "update:active": function($event) {
                  _vm.loading = $event
                }
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "top-right",
        fn: function() {
          return [
            _c("DeleteLayersMap", {
              on: {
                "map-restart": _vm.mapRestart,
                "set-shape-geom": function($event) {
                  _vm.shapeGeom = $event
                }
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "bottom-right",
        fn: function() {
          return [
            _c("TableViewLayerObjects", {
              ref: "tableLayerObjects",
              attrs: {
                layer: _vm.layer,
                workspaceUuid: _vm.selectedWorkspace.uuid,
                workspaceGeoJson: _vm.selectedWorkspace.geoJson,
                shapeGeom: _vm.shapeGeom
              },
              on: {
                "clear-shape-geom": function($event) {
                  _vm.shapeGeom = null
                },
                "clear-selected-workspace": _vm.clearSelectedWorkspace
              }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d61dd87", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d61dd87","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/DeleteLayers.vue
// module id = null
// module chunks = 